import React from "react";
import { useTranslation } from "react-i18next";
import { useLanguageStore } from "../../store/layout/useLanguageStore";
import ArIcon from "../../assets/icons/ArIcon";
import EnIcon from "../../assets/icons/EnIcon";

type LanguageSwitcherProps = {
  iconColor?: string;
  iconSize?: number;
};

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  iconColor = "#034121",
  iconSize = 30,
}) => {
  const { i18n } = useTranslation();
  const { setLanguage } = useLanguageStore();

  const changeLanguage = (language: string) => {
    const direction = language === 'ar' ? 'rtl' : 'ltr';
    i18n.changeLanguage(language);
    setLanguage(language, direction);
    document.documentElement.dir = direction;
  };

  return (
    <button
      onClick={() => changeLanguage(i18n.language === 'en' ? 'ar' : 'en')}
    >
      {i18n.language === 'en'
        ? <ArIcon color={iconColor} width={iconSize} height={iconSize} />
        : <EnIcon color={iconColor} width={iconSize} height={iconSize} />}
    </button>
  );
};

export default LanguageSwitcher;
